"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorTracingType = void 0;
var constants_1 = require("../../constants");
var getErrorTracingType = function (_a) {
    var requestError = _a.requestError, responseError = _a.responseError, validationError = _a.validationError;
    if (validationError) {
        return constants_1.TRACING_ERRORS.VALIDATION_ERROR;
    }
    if (responseError) {
        return constants_1.TRACING_ERRORS.RESPONSE_ERROR;
    }
    if (requestError) {
        return constants_1.TRACING_ERRORS.REQUEST_ERROR;
    }
    return null;
};
exports.getErrorTracingType = getErrorTracingType;
